import ManageUser from './manageUser'

export default ManageUser
